import FleetRouteIslandCard from "./FleetRouteIslandCard";

const FormFleetRouteIslands = ({islands, wasteType, highlighted, setHighligthed}) => {
    return (
        <ul className="list-unstyled">
            {islands.map((wp, index) => (
                <li className="row" key={wp?.id ?? wp?.order ?? index}>
                    <div className="col border rounded p-2 mb-3 bg-white">
                        <FleetRouteIslandCard
                            planned={wp}
                            executed={wp.executed}
                            wasteType={wasteType}
                            highlighted={wp?.id != null && highlighted === wp.id}
                            onToggleHighlight={
                                // un clic resalta el punto en el mapa; otro clic en el mismo lo quita
                                wp?.id != null ? () => setHighligthed(highlighted === wp.id ? null : wp.id) : null
                            }
                        />
                    </div>
                </li>
            ))}
        </ul>
    );
};
export default FormFleetRouteIslands;
